module.exports = __webpack_public_path__ + "static/media/print.3e92dc6e.svg";